import { memo } from 'react'
import { FaArrowLeft } from 'react-icons/fa'
import { useTranslate } from '../../../../../hooks/language/use-translate'
import { useGetGamesBoxesRoomsDetails } from '../../../../../hooks/queries/games/games-boxes-rooms-details/use-get-games-boxes-rooms-details'
import { useGetGamesBoxesRoomsDetailsCount } from '../../../../../hooks/queries/games/games-boxes-rooms-details/use-get-games-boxes-rooms-details-count'
import type { GameBoxRoom } from '../../../../../services/games/games-boxes-rooms/types'

interface Props {
  selectedGameBox: GameBoxRoom
  handleBack: () => void
}

export const ModalHistoryDetails = memo(
  ({ selectedGameBox, handleBack }: Props) => {
    const { translate } = useTranslate()

    const totalReturn =
      selectedGameBox?.valueTotalDistribute *
      selectedGameBox?.quantityPeopleEarning

    const { gamesBoxesRoomsDetails } = useGetGamesBoxesRoomsDetails({
      gameBoxRoomId: selectedGameBox?.id,
    })

    const { gamesBoxesRoomsDetailsCount } = useGetGamesBoxesRoomsDetailsCount({
      gameBoxRoomId: selectedGameBox?.id,
    })

    return (
      <div className="w-screen h-screen flex flex-col z-50">
        <div className="bg-white h-full rounded-t-3xl py-5 flex flex-col overflow-y-auto">
          <div className="flex justify-center gap-8 mb-4 relative border-b border-b-gray-200">
            <FaArrowLeft
              className="absolute top-1 left-4 text-gray-400"
              onClick={handleBack}
            />

            <span className="pb-2 font-semibold text-gray-500">
              {translate('modal-description-register-receive')}
            </span>
          </div>

          <div className="px-4">
            <div className="overflow-y-scroll overflow-x-hidden mt-2">
              <div className="flex flex-col w-full p-2 bg-white border border-gray-200 rounded-sm">
                <div className="mb-2">
                  <span className="text-[10px] leading-none text-gray-500">
                    {translate('modal-description-register-conditions')}
                  </span>
                </div>

                <div className="flex flex-row mb-2">
                  <span className="text-4xl">🎁</span>

                  <div className="ml-2">
                    <span className="text-sm text-gray-800">
                      {translate('modal-description-register-equal-division')}
                    </span>

                    <div className="flex flex-row gap-1">
                      <div className="flex flex-row px-2  gap-1 bg-red-100 rounded-2xl items-center justify-center">
                        <span className="text-[8px]">🎁</span>
                        <span className="text-[8px] text-red-600 font-bold">
                          {selectedGameBox?.quantityPeopleEarning}
                        </span>
                      </div>

                      <div className="flex flex-row px-2 gap-1 bg-amber-100 rounded-2xl items-center justify-center">
                        <span className="text-[8px]">🪙</span>

                        <span className="text-[8px] text-amber-600 font-bold">
                          {totalReturn}
                        </span>
                      </div>
                    </div>
                  </div>

                  <div className="flex flex-col flex-1 justify-center items-end">
                    <div className="flex flex-col">
                      <div className="flex flex-row gap-2">
                        <span className="text-[10px]">
                          {translate(
                            'modal-description-register-people-received',
                            gamesBoxesRoomsDetailsCount?.count || 0,
                          )}
                        </span>
                      </div>

                      <span className="text-[8px] text-gray-400">
                        {translate(
                          'modal-description-register-return',
                          totalReturn,
                        )}
                      </span>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>

          <div className="flex flex-col px-4 mt-6 gap-4">
            {gamesBoxesRoomsDetails?.map((gameBoxRoomDetail) => (
              <div
                key={gameBoxRoomDetail?.id}
                className="w-full flex flex-row text-gray-900 items-center justify-between gap-2"
              >
                <div className="flex flex-row items-center gap-4">
                  <img
                    src={gameBoxRoomDetail?.user?.imgUser}
                    className="w-10 h-10 bg-black rounded-full"
                  />

                  <span className="text-xs font-bold">
                    {gameBoxRoomDetail?.user?.username}
                  </span>
                </div>

                <div className="flex flex-row px-2 gap-1 bg-amber-100 rounded-2xl items-center justify-center">
                  <span className="text-sm">🪙</span>

                  <span className="text-sm text-amber-600 font-bold">
                    {gameBoxRoomDetail?.valueEarning}
                  </span>
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>
    )
  },
)

ModalHistoryDetails.displayName = 'ModalHistoryDetails'
